const Lang             = require('lang');
const selectorButton   = '[data-clean-form-search]';
const classShowContent = 'show-content';
const classFormActive  = 'active';

/**
 * Classe que expande ou contrai o restante dos campos
 * de filtro de pesquisa
 */
function CleanFormSearchShowFilters() {
  const buttons = document.querySelectorAll(selectorButton);

  if (buttons.length) {
    buttons.forEach((currentButton) => {
      currentButton.addEventListener('click', handlerClick);
    })
  }
}

/**
 * Callback do evento de click no botão e expansão/
 * contração do filtro do formulário
 *
 * @param {Event} event
 */
function handlerClick(event) {
  const button = event.target;
  const idContentHidden = button.dataset.content;
  const idFormFilter = button.dataset.form;
  const elementForm = document.querySelector(idFormFilter);
  const elementContentHidden = document.querySelector(idContentHidden);

  elementContentHidden.classList.toggle(classShowContent);
  elementForm.classList.toggle(classFormActive);

  const formActive = elementForm.classList.contains(classFormActive);

  button.innerHTML = formActive
    ? Lang.get('js/src/functions/CleanFormSearchShowFilters.to_hide_filters')
    : Lang.get('js/src/functions/CleanFormSearchShowFilters.show_filters');
}

exports.init = CleanFormSearchShowFilters;
